// extracted by mini-css-extract-plugin
export default {"list":"list--wQio0","tab":"tab--wQio0","icon":"icon--wQio0","label":"label--wQio0","active":"active--wQio0"};